import React from "react";
import PropTypes from "prop-types";
import "./Box.css";

const Box = (props) => {
  return (
    <div
      id={props.id}
      className={
        props.className ? `${props.className} box-container` : "box-container"
      }>
      {props.children ? props.children : null}
    </div>
  );
};

Box.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
};

export default Box;
